import { adminHttpClient } from '../../../commons/adminHttpClient'

export type UserClassAssignment = {
  companyUserId: string
  productClassId: string
}

const importUsersFromOtherProduct = (values: { companyUserInputs: UserClassAssignment[] }): Promise<any> => {
  return adminHttpClient.post('/Companies/ImportUsersFromExistingProduct', values)
}

export default importUsersFromOtherProduct
